import React from "react";
import SideButton from "components/SideButton/SideButton";
import SyncIcon from "@mui/icons-material/Sync";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/material";

export interface SideButtonsGroupProps {
  onResetClick: () => void;
  onSimulationClick: () => void;
  onCloseClick: () => void;
  direction: "row" | "column";
}
const SideButtonsGroup = ({
  onResetClick,
  onSimulationClick,
  onCloseClick,
  direction,
}: SideButtonsGroupProps) => {

  const isBottomPlacement = direction === "row";

  return (
    <Stack
      direction={direction}
      justifyContent="center"
      alignItems="center"
      gap={1}
      sx={{ width: "auto", height: "auto", margin: "0", p: '10px 0 0 10px' }}
    >
      <SideButton
        backgroundColor="#ffc737"
        title="Simulate Bet"
        onClick={() => onSimulationClick()}
        isAnimated={false}
        isBottomPlacement={isBottomPlacement}
      />
      <SideButton
        backgroundColor="#c7c7c7"
        icon={<SyncIcon sx={{ width: "40px", height: "40px" }} />}
        onClick={() => onResetClick()}
        isAnimated={true}
      />
      <SideButton
        backgroundColor="#c7c7c7"
        icon={<CloseIcon sx={{ width: "40px", height: "40px" }} />}
        onClick={() => onCloseClick()}
        isAnimated={false}
      />
    </Stack>
  );
};

export default SideButtonsGroup;
